export default __webpack_public_path__ + "static/media/bjBgWnds.cdbf2cbe.webp";